export default function () {
  return {
    loggedIn: false,
    id: null,
    email: null,
    firstname: null,
    surname: null,
    uk_based: null,
    gender: null,
    postcode: null,
    jobRoles: [],
    institution_start_year: 0,
    competitions_subscription: 0,
    courses_subscription: 0,
    jobs_subscription: 0,
    subscription_decision: 0,

    // NEW

    jobTypes: [],
    fullname: null,

    profile_completion: 0,

    re_auth_is_required: null,
    re_auth_last_done_at_utc: null,
    re_auth_next_required_at_utc: null,

    isAdmin: false,
    isEmailChangePending: false,
    isEmailChangeable: false,
    isPasswordChangeable: false,

    ethnicity: null,
    parent_profession: null,
    free_school_meals: null,
  };
}
